import { SettingsForm, type FieldSpec } from "../SettingsForm.js";

const FIELDS: FieldSpec[] = [
  { kind: "group", label: "Identität" },
  { kind: "text", key: "platformName", label: "Plattformname", placeholder: "ELMETIC EnergyOS" },
  {
    kind: "select", key: "language", label: "Sprache",
    options: [
      { value: "de-AT", label: "Deutsch (Österreich)" },
      { value: "de-DE", label: "Deutsch (Deutschland)" },
      { value: "en", label: "English" },
    ],
  },
  { kind: "text", key: "timezone", label: "Zeitzone", placeholder: "Europe/Vienna", help: "IANA-Zeitzone, z. B. Europe/Vienna." },

  { kind: "group", label: "Region & Währung" },
  {
    kind: "select", key: "currency", label: "Währung",
    options: [{ value: "EUR", label: "Euro (€)" }, { value: "CHF", label: "Schweizer Franken (CHF)" }],
  },
  {
    kind: "select", key: "defaultCountry", label: "Standardland",
    options: [{ value: "AT", label: "Österreich" }, { value: "DE", label: "Deutschland" }, { value: "CH", label: "Schweiz" }],
  },
  {
    kind: "select", key: "defaultRegion", label: "Standard-Bundesland",
    options: [
      { value: "", label: "— keines —" },
      { value: "B", label: "Burgenland" },
      { value: "K", label: "Kärnten" },
      { value: "NÖ", label: "Niederösterreich" },
      { value: "OÖ", label: "Oberösterreich" },
      { value: "S", label: "Salzburg" },
      { value: "ST", label: "Steiermark" },
      { value: "T", label: "Tirol" },
      { value: "V", label: "Vorarlberg" },
      { value: "W", label: "Wien" },
    ],
  },

  { kind: "group", label: "Steuer & Tarife (Standardwerte)" },
  { kind: "number", key: "vatPercent", label: "Mehrwertsteuer", min: 0, max: 100, step: 0.1, suffix: "%" },
  { kind: "number", key: "defaultElectricityPriceEurPerKwh", label: "Standard-Strompreis", min: 0, max: 5, step: 0.001, suffix: "€/kWh" },
  { kind: "number", key: "defaultFeedInTariffEurPerKwh", label: "Standard-Einspeisetarif", min: 0, max: 5, step: 0.001, suffix: "€/kWh" },
];

export function AllgemeinSection() {
  return (
    <SettingsForm
      category="general"
      title="Allgemein"
      intro="Globale Plattformparameter. Diese Standardwerte dienen als Vorbelegung in Projekten und Berechnungen."
      fields={FIELDS}
    />
  );
}
